// extracted by mini-css-extract-plugin
module.exports = {"link":"DataTableLinkTemplate_link__237TD"};